import { api } from './axios';

export type StaffStatus = 'PRESENT' | 'ABSENT' | 'LATE' | 'HALF_DAY' | 'LEAVE' | 'HOLIDAY';
export type StaffHalfDay = 'MORNING' | 'AFTERNOON';

export interface StaffAttendanceRow {
  id: number | null;
  staffId: number;
  registrationNumber: string | null;
  staffName: string | null;
  designationName: string | null;
  departmentName: string | null;
  status: StaffStatus | null;
  halfDayType: StaffHalfDay | null;
  reason: string | null;
  leaveRequestId: number | null;
  manualOverride: boolean;
}

export interface StaffSheet {
  date: string;
  totalStaff: number;
  present: number;
  absent: number;
  late: number;
  halfDay: number;
  leave: number;
  notMarked: number;
  rows: StaffAttendanceRow[];
}

export interface StaffMonthRow {
  staffId: number;
  staffName: string;
  present: number;
  absent: number;
  late: number;
  halfDay: number;
  leave: number;
  notMarked: number;
}

export interface StaffMonthSummary {
  from: string;
  to: string;
  workingDays: number;
  rows: StaffMonthRow[];
}

export const staffAttendanceApi = {
  sheet: (date: string) =>
    api.get<StaffSheet>('/hr/attendance/sheet', { params: { date } }).then((r) => r.data),
  save: (body: { date: string; entries: { staffId: number; status: StaffStatus; halfDayType?: StaffHalfDay; reason?: string }[] }) =>
    api.post<StaffSheet>('/hr/attendance/sheet', body).then((r) => r.data),
  summary: (from: string, to: string) =>
    api.get<StaffMonthSummary>('/hr/attendance/summary', { params: { from, to } }).then((r) => r.data),
};
